import Property from '@/entities/Property';

export default class Model extends Property {
    public makeId: number = null;
}
